import type { Period } from '@/entities/types';
import { AiPanel } from './AiPanel';

interface SidePaneProps {
  period: Period;
  targetStartAt: Date;
  className?: string;
}

export function SidePane({ className, period, targetStartAt }: SidePaneProps) {
  return (
    <div
      className={`border-r-1 flex min-h-0 min-w-0 flex-col border-r-slate-200 ${className || ''}`}
    >
      <AiPanel
        period={period}
        targetStartAt={targetStartAt}
        className="flex-1 px-5 pb-5"
      />
    </div>
  );
}
